export default {
    companySetting: 'ตั้งค่าบริษัท',
    profile: 'ประวัติ',
    branch: 'สาขา',
    userManagement: 'จัดการผู้ใช้',
    department: 'แผนก',
    companyHoliday: 'วันหยุดบริษัท',
    leaveQuota: 'โควต้าการลา',
    blacklist: 'บุคคลต้องห้าม'
}
